import { Controller } from "stimulus";
import Splide from "@splidejs/splide";

export default class extends Controller {
  static targets = ["loader", "wrapper"];

  initialize() {
    const primarySlider = new Splide(this.wrapperTarget);

    primarySlider.mount();
    // primarySlider.on("mount", this.onCreate());
  }
}
